<template>
  <div class="modal fade" id="warning" tabindex="-1" aria-labelledby="warning" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-gradient-danger" id="warningModalHeader">
          <h5 class="modal-title" id="warningModalLabel"></h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <h4>آیا از حذف {{ user.lastName + ' ' + user.firstName }} اطمینان دارید؟!</h4>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn bg-gradient-success" data-bs-dismiss="modal">خیر</button>
          <button type="button" class="btn bg-gradient-danger" data-bs-dismiss="modal" @click="deleteUser">حذف</button>
        </div>
      </div>
    </div>
  </div>
  <div class="py-4 container-fluid">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <label class="form-control-label" for="filterField">جستجو</label>
            <input class="form-control" type="text" id="filterField" name="filterField" v-model.trim="filterField" />
          </div>
          <div class="col-md-4" v-if="getPermission(1050).view">
            <label class="form-control-label">انتخاب شرکت برای نمایش کاربران</label>
            <treeselect
              v-model="companyId"
              :multiple="false"
              placeholder="انتخاب کنید"
              :showCount="true"
              noOptionsText="هنوز شرکتی تعریف نشده است"
              noResultsText="موردی یافت نشد"
              noChildrenText="این شرکت فاقد زیر مجموعه است"
              :options="companies"
              @open="reloadCompanies"
              />
          </div>
          <div
            v-if="getPermission(1050).view | getPermission(1120).view | !this.$store.state.currentUserInfo.isCompanyUser"
            class="col-md-4"
            >
            <label class="form-control-label">انتخاب مشتری برای نمایش کاربران</label>
            <treeselect
              v-model="customerId"
              :multiple="false"
              placeholder="انتخاب کنید"
              :showCount="true"
              noOptionsText="هنوز مشتری ای تعریف نشده است"
              noResultsText="موردی یافت نشد"
              noChildrenText="این مشتری فاقد زیر مجموعه است"
              :options="customers"
              @open="reloadCustomers"
              />
          </div>
        </div>
        <div>
          <hr class="horizontal dark" />
        </div>
        <div class="table-responsive p-0">
          <table class="table table-striped table-styled table-sm">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">نام</th>
                <th scope="col">نام خانوادگی</th>
                <th scope="col">جنسیت</th>
                <th scope="col">کد ملی</th>
                <th scope="col">سمت</th>
                <th scope="col">موبایل</th>
                <th scope="col">تلفن محل کار</th>
                <th scope="col">ایمیل</th>
                <th scope="col">تاریخ تولد</th>
                <th scope="col" v-if="customerId > 0">ادمین</th>
                <th scope="col">فعال</th>
                <th scope="col">امکانات</th>
              </tr>
            </thead>
            <tbody>
              <tr></tr>
              <tr v-for="(u, index) in filteredUsers">
                <td>{{ index + 1 }}</td>
                <td>{{ u.firstName }}</td>
                <td>{{ u.lastName }}</td>
                <td>{{ (u.gender == 1) ? "مرد" : ((u.gender == 2) ? "زن" : "") }}</td>
                <td>{{ u.username }}</td>
                <td>{{ u.postTitle }}</td>
                <td>{{ u.phone }}</td>
                <td dir="ltr">{{ u.workPhone }} {{ u.workPhoneInternalCode ? ' - ' + u.workPhoneInternalCode : '' }}</td>
                <td>{{ u.email }}</td>
                <td>{{ this.$filters.toDateString(u.dateOfBirth) }}</td>
                <td v-if="customerId > 0">
                  <div class="d-inline-flex text-white p-1 table-check bg-success" v-if="u.isAdmin">
                    <i class="ni ni-check-bold" />
                  </div>
                </td>
                <td>
                  <div class="d-inline-flex text-white p-1 table-check bg-success" v-if="u.isActive">
                    <i class="ni ni-check-bold" />
                  </div>
                  <div class="d-inline-flex text-white p-1 table-check bg-danger" v-else>
                    <i class="ni ni-fat-remove" />
                  </div>
                </td>
                <td>
                  <button
                    v-if="companyId > 0 & (getPermission(1050).update | getPermission(1070).update) & (getPermission(1040).view | getPermission(1080).view)"
                    class="btn btn-sm bg-gradient-success mb-0"
                    @click="goToAccessGroups(u.id)"
                    title="نقش ها"
                    >
                    <fa-icon icon="fas fa-key" />
                  </button>
                  <button
                    v-if="getPermission(1050).update | getPermission(1070).update | getPermission(1120).update | !this.$store.state.currentUserInfo.isCompanyUser"
                    class="btn btn-sm bg-gradient-warning mb-0"
                    @click="goToEdit(u.id)" title="ویرایش"
                    >
                    <fa-icon icon="fas fa-pencil" />
                  </button>
                  <button
                    v-if="getPermission(1050).update | getPermission(1070).update | getPermission(1120).update | !this.$store.state.currentUserInfo.isCompanyUser"
                    class="btn btn-sm bg-gradient-primary mb-0"
                    @click="goToChangePass(u.id)" title="تغییر کلمه عبور"
                    >
                    <fa-icon icon="fas fa-unlock-alt" />
                  </button>
                  <button
                    v-if="getPermission(1050).delete | getPermission(1070).delete | getPermission(1120).delete"
                    class="btn btn-sm bg-gradient-danger mb-0"
                    @click="setUser(u)" data-bs-toggle="modal"
                    data-bs-target="#warning"
                    title="حذف"
                    >
                  <fa-icon icon="fas fa-trash" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <hr class="horizontal dark" />
      </div>
      <div>
        <button
          v-if="getPermission(1050).insert | getPermission(1070).insert | getPermission(1120).insert"
          class="btn bg-gradient-success mb-0"
          @click="goToAddUser"
          >
        اضافه کردن کاربر جدید
        </button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import UserService from "@/services/User/User-service.js";
import Treeselect from '@cholakovdev/vue3-treeselect';
import { mapGetters } from "vuex";

export default {
  components: { Treeselect },
  data() {
    return {
      users: [],
      user: {},
      companies: [],
      companyId: null,
      customers: [],
      customerId: null,
      oldId: null,
      filterField: "",
    };
  },
  watch: {
    companyId(company) {
      if (typeof (company) === 'number' && typeof (this.customerId) === 'number' && this.getPermission(1050).view) {
        this.customers = [{ id: this.customerId, label: '', pH: true }];
        this.oldId = this.customerId;
        this.customerId = null;
      }

      if (typeof (company) === 'number') {
        this.getUsersByCompany();
      }
      else {
        this.users = [];
      }
    },
    customerId(customer) {
      if (typeof (customer) === 'number' && typeof (this.companyId) === 'number' && this.getPermission(1050).view) {
        this.companies = [{ id: this.companyId, label: '', pH: true }];
        this.oldId = this.companyId;
        this.companyId = null;
      }

      if (typeof (customer) === 'number') {
        this.getUsersByCustomer();
      }
      else if(typeof (this.companyId) === 'number'){
        this.getUsersByCompany();
      }
      else {
        this.users = [];
      }
    }
  },
  computed:{
    ...mapGetters(['getPermission']),
    filteredUsers(){
      if(!this.filterField | this.filterField == ""){
        return this.users;
      }
      return this.users.filter(x => x.filterProp.includes(this.filterField));
    },
  },
  methods: {
    getUsersByCompany() {
      setTimeout(() =>
        UserService.getListByCompanyId(this.companyId).then(response => {
          let result = response.data;
          
          if (!result.success) {
            this.$toast.error(result.message);
          }
          else {
            this.users = result.data.map(x => ({...x, filterProp: (x.firstName + " " + x.lastName + " " + x.postTitle)}));
          }
        }).catch(e => {
          console.log(e);
        }),
        100);
    },
    getUsersByCustomer() {
      setTimeout(() =>
        UserService.getListByCustomerId(this.customerId).then(response => {
          let result = response.data;

          if (!result.success) {
            this.$toast.error(result.message);
          }
          else {
            this.users = result.data.map(x => ({...x, filterProp: (x.firstName + " " + x.lastName + " " + x.postTitle)}));
          }
        }).catch(e => {
          console.log(e);
        }),
        100);
    },
    goToUserDetails(userId) {
      this.$router.push('/userDetails/' + userId);
    },
    goToAddUser() {
      this.$router.push('/adduser');
    },
    setUser(user) {
      this.user = user;
    },
    deleteUser() {
      let userId = this.user.id;

      UserService.delete(userId).then(response => {
        let result = response.data;

        if (result.success) {
          this.$toast.success(result.message);

          let index = this.users.indexOf(this.user);
          this.users.splice(index, 1);
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    goToEdit(userId) {
      this.$router.push('/editUser/' + userId);
    },
    goToChangePass(userId) {
      this.$router.push('/ChangeUserPass/' + userId);
    },
    goToAccessGroups(userId) {
      this.$router.push('/UserAccessGroups/' + userId);
    },
    reloadCompanies() {
      if (this.companies[0].pH && this.getPermission(1050).view) {
        this.companyId = this.oldId;
        this.companies = [];
        this.companies.push(this.$store.state.currentUserInfo.companies);
      }
    },
    reloadCustomers() {
      if (this.customers[0].pH && this.getPermission(1050).view) {
        this.customerId = this.oldId;
        this.customers = [];
        this.customers = this.$store.state.currentUserInfo.customers;
      }
    }
  },
  created() {
    if (this.$store.state.currentUserInfo.companies) {
      this.companies.push(this.$store.state.currentUserInfo.companies);
      this.customers = this.$store.state.currentUserInfo.customers;
      if(this.getPermission(1050).view | this.getPermission(1070).view){
        this.companyId = this.$store.state.currentUserInfo.companies.id;
      }
    }
    else {
      this.customers.push(this.$store.state.currentUserInfo.customers);
      this.customerId = this.$store.state.currentUserInfo.customers.id;
    }
  }
}
</script>